import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Loading from "@views/Loading"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '预约&挂号'
    }
  },
  {
    path: '/department',
    name: 'Department',
    component: () => import('../views/Department.vue')
  },
  {
    path: '/order-create',
    name: 'OrderCreate',
    component: () => import('../views/OrderCreate.vue')
  },
  {
    path: '/order-view',
    name: 'OrderView',
    component: () => import('../views/OrderView.vue'),
    meta: {
      title: '订单查看'
    }
  },
  {
    path: '/order-list',
    name: 'OrderList',
    component: () => import('../views/OrderList.vue'),
    meta: {
      title: '订单列表'
    }
  },
  {
    path: '/patient-list',
    name: 'PatientList',
    component: () => import('../views/PatientList.vue'),
    meta: {
      title: '就诊人列表'
    }
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('../views/Setting.vue'),
    meta: {
      title: '设置'
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@views/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: "/auth/:url",
    name: "Loading",
    meta: {
      title: " 加载中"
    },
    component: Loading
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@views/NotFound.vue'),
    meta: {
      title: '页面未找到'
    }
  }
]

const router = new VueRouter({
  // hash
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

console.log('process.env.BASE_URL=' + process.env.BASE_URL)

export default router
